import { render, staticRenderFns } from "./SuiteTemplateSocialNetwork.vue?vue&type=template&id=a2017890&"
import script from "./SuiteTemplateSocialNetwork.vue?vue&type=script&lang=js&"
export * from "./SuiteTemplateSocialNetwork.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports